import { UI_DESIGN_OPTIONS, DEFAULT_UI_DESIGN_VERSION } from '../constants/bookingConst';

/**
 * The UI design option (Config -> Theme -> UI Design) for a stored value,
 * falling back to the default design for a missing or unknown value — a config
 * saved before the setting existed, or a version since retired.
 *
 * @param {string|undefined|null} value - config.uiDesignVersion
 * @returns {{value: string, label: string, description: string, previewUrl: string}}
 */
export const resolveUiDesignOption = (value) => (
  UI_DESIGN_OPTIONS.find(option => option.value === value)
  || UI_DESIGN_OPTIONS.find(option => option.value === DEFAULT_UI_DESIGN_VERSION)
);

/**
 * "Version 1" / "Version 2" for a stored value, for the audit trail.
 *
 * @param {string|undefined|null} value - config.uiDesignVersion
 * @returns {string}
 */
export const getUiDesignLabel = (value) => resolveUiDesignOption(value).label;
